import React from 'react';
import Header from '../components/Header';
import PrivacySection from '../components/PrivacySection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { getSEOMetadataForRoute } from '../utils/seoMetadata';
import styles from './PrivacyPage.module.css';

/**
 * PrivacyPage component displays the privacy policy page
 * Implements requirements 1.2, 2.2, 2.5 for privacy policy display
 */
const PrivacyPage: React.FC = () => {
  // Get SEO metadata for privacy page
  const seoMetadata = getSEOMetadataForRoute('/privacy');

  // Dummy state for Header component compatibility
  const [activeSection] = React.useState<string>('privacy');

  return (
    <div className={styles.privacyPage}>
      <SEOHead metadata={seoMetadata} currentPath="/privacy" />
      <Header
        activeSection={activeSection}
        onSectionChange={() => {
          /* No-op for privacy page */
        }}
      />
      <main id="main-content" className={styles.main}>
        <PrivacySection />
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
